import React from "react";

const ValentinoLogo = ({ className = "" }) => {
  return (
   <svg
  className={className}
  viewBox="0 0 1983 793"
  xmlns="http://www.w3.org/2000/svg"
  role="img"
  aria-labelledby="valentino-logo-title"
  preserveAspectRatio="xMinYMid meet"
>
      <title id="valentino-logo-title">Valentino</title>

      
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M1850.903076,425.010712 
	C1844.670654,428.322968 1838.421265,429.653503 1831.742798,429.036682 
	C1830.420410,428.914520 1829.077759,429.006836 1827.744507,429.006805 
	C1802.244995,429.005890 1776.744995,428.919464 1751.246216,429.050659 
	C1741.759155,429.099457 1732.276611,429.723846 1722.788940,429.970490 
	C1703.719604,430.466156 1684.240356,421.938599 1677.100342,401.761658 
	C1675.210693,396.421448 1674.214844,390.505798 1674.125610,384.833679 
	C1673.787354,363.339386 1673.960083,341.836578 1674.000244,320.337067 
	C1674.028687,305.139038 1684.792847,287.945343 1699.373657,282.599060 
	C1705.863037,280.219604 1712.048584,278.948792 1718.799683,278.961761 
	C1755.465454,279.032196 1792.136719,279.353821 1828.794800,278.812988 
	C1842.779663,278.606659 1854.563721,282.511444 1863.894043,292.589752 
	C1871.144165,300.420959 1875.527832,309.783325 1875.062622,320.948578 
	C1874.785400,327.603180 1875.011841,334.278717 1875.011841,341.582611 
	C1866.185181,341.582611 1857.376953,341.582611 1847.990112,341.582611 
	C1847.990112,336.721771 1848.002319,331.618439 1847.987793,326.515137 
	C1847.952515,314.137238 1840.917236,307.011475 1828.749756,307.011566 
	C1792.083740,307.011871 1755.416382,307.190918 1718.752808,306.888855 
	C1709.286621,306.810883 1701.126709,314.124390 1701.052124,324.069702 
	C1700.902100,344.068237 1700.825073,364.070892 1701.077637,384.067291 
	C1701.198486,393.622345 1710.416626,401.295197 1718.641968,401.192932 
	C1756.135376,400.727020 1793.638550,400.882294 1831.136963,401.068542 
	C1839.747925,401.111328 1848.081909,393.679047 1847.972778,384.619568 
	C1847.843140,373.835541 1847.942017,363.048767 1847.942017,352.499084 
	C1857.090332,352.499084 1865.846069,352.499084 1875.230957,352.499084 
	C1875.230957,365.582367 1876.477905,379.018219 1874.898315,392.113068 
	C1873.137939,406.705688 1864.778564,418.049255 1850.903076,425.010712 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M210.677383,409.193787 
	C204.936768,400.964081 199.459503,392.992584 194.012970,385.000061 
	C180.922470,365.790375 167.923523,346.517731 154.735794,327.375061 
	C146.717804,315.736542 138.546371,304.198303 130.204956,292.789673 
	C122.938942,282.851837 115.335686,273.160645 107.895172,263.350037 
	C107.647301,263.023193 107.548737,262.583099 107.291817,261.991394 
	C121.156578,261.991394 134.773056,261.898407 148.384445,262.119385 
	C149.933395,262.144531 151.953918,263.581940 152.913696,264.953674 
	C173.110275,293.819122 192.990326,322.907806 213.357880,351.651215 
	C225.608047,368.939117 238.584656,385.712128 251.219193,402.728088 
	C251.982208,403.755707 252.607162,404.885864 253.795151,406.751709 
	C255.723343,404.327179 257.453644,402.344360 258.972931,400.211273 
	C274.324005,378.658325 289.701660,357.123779 304.937195,335.489227 
	C311.156677,326.657532 316.914185,317.500885 323.118408,308.657990 
	C332.397095,295.432953 342.273163,282.608490 351.107544,269.098633 
	C355.085510,263.015381 359.601105,261.459473 366.367767,261.849884 
	C376.130676,262.413177 385.950287,261.993927 396.419006,261.993927 
	C391.573608,269.328949 387.212067,276.230316 382.552368,282.924103 
	C372.430542,297.464172 362.119080,311.872070 351.952820,326.381409 
	C333.976227,352.037628 316.030426,377.715515 298.114288,403.414001 
	C292.281158,411.780914 286.421692,420.137390 280.878815,428.695892 
	C277.513367,433.892334 273.448029,429.753448 269.882690,429.799622 
	C257.615021,429.958588 245.337677,429.199982 233.063599,429.186859 
	C230.798874,429.184448 228.532150,431.025299 226.550873,431.891083 
	C221.214645,424.210266 216.084671,416.826324 210.677383,409.193787 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M1489.713135,287.049744 
	C1499.242188,295.350616 1508.537231,303.370483 1517.849976,311.369751 
	C1524.805420,317.344147 1531.808105,323.263733 1538.746826,329.257629 
	C1551.259644,340.066681 1563.774048,350.874207 1576.220337,361.759674 
	C1582.908569,367.609070 1589.421997,373.658173 1596.078613,379.544434 
	C1601.646240,384.467957 1607.307251,389.285797 1613.683716,394.805450 
	C1613.683716,355.800995 1613.683716,317.666687 1613.683716,278.954651 
	C1622.966797,278.954651 1631.699463,278.954651 1640.712646,278.954651 
	C1640.712646,328.706665 1640.712646,379.040161 1640.712646,429.140594 
	C1634.710449,429.140594 1628.627441,428.677704 1622.645996,429.259521 
	C1615.408203,429.963470 1609.555420,429.157166 1603.748047,423.601532 
	C1590.835327,411.248505 1577.026733,399.829498 1563.536499,388.083466 
	C1553.909302,379.700897 1544.220093,371.389221 1534.533447,363.075165 
	C1518.325562,349.163727 1502.077148,335.299164 1485.892090,321.361053 
	C1481.858643,317.887543 1478.002441,314.208160 1473.312500,309.938568 
	C1473.312500,350.299805 1473.312500,389.392914 1473.312500,429.087921 
	C1463.856812,429.087921 1454.984375,429.087921 1446.150146,429.087921 
	C1446.150146,379.373260 1446.150146,329.422058 1446.150146,278.992401 
	C1454.580200,278.992401 1462.891968,279.458649 1471.122925,278.844269 
	C1477.658813,278.356415 1482.862915,279.564545 1486.723267,285.124664 
	C1487.278320,285.923981 1488.547852,286.227173 1489.713135,287.049744 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M945.572266,286.886841 
	C945.487915,284.196625 945.102783,281.837616 944.639526,278.999939 
	C956.252625,278.999939 967.284546,278.293579 978.136169,279.382874 
	C981.937073,279.764404 985.397644,284.440979 988.837219,287.363739 
	C1004.927979,301.036438 1021.009338,314.721039 1036.990356,328.521545 
	C1048.187256,338.190704 1059.210938,348.060059 1070.322754,357.827850 
	C1084.161987,369.993195 1098.012085,382.146149 1112.780273,395.114624 
	C1112.780273,355.738831 1112.780273,317.590698 1112.780273,278.875122 
	C1122.058960,278.875122 1130.801758,278.875122 1139.763184,278.875122 
	C1139.763184,328.350647 1139.763184,378.397827 1139.763184,429.009399 
	C1134.179810,429.009399 1128.361206,428.012146 1123.042725,429.218872 
	C1112.270020,431.663177 1105.268921,425.894318 1098.203857,419.685913 
	C1086.448242,409.355865 1074.873169,398.818329 1063.025513,388.595947 
	C1052.362183,379.395355 1041.393311,370.549683 1030.642090,361.449493 
	C1025.553223,357.142151 1020.711609,352.543854 1015.664429,348.185730 
	C1003.071838,337.312134 990.406738,326.522552 977.823608,315.638153 
	C976.132324,314.175232 974.746216,312.359589 972.257080,309.666931 
	C972.257080,350.574829 972.257080,390.063538 972.257080,429.313843 
	C963.061707,429.313843 954.430176,429.313843 945.011169,429.313843 
	C945.011169,406.706451 944.895386,384.171509 945.054382,361.638519 
	C945.150146,348.061005 945.882629,334.487274 945.933228,320.910339 
	C945.968872,311.336060 945.319214,301.759918 945.026978,292.183014 
	C944.976562,290.532074 945.183533,288.873291 945.572266,286.886841 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M462.263702,295.748199 
	C493.970184,340.156891 525.415039,384.304810 557.952087,429.986084 
	C546.978210,429.986084 537.447266,429.876556 527.921082,430.039337 
	C524.044922,430.105560 521.380737,429.078857 518.975220,425.657135 
	C503.370636,403.460449 487.570740,381.399689 471.685730,359.402100 
	C465.067688,350.237396 458.060852,341.354095 451.290527,332.298126 
	C450.283203,330.950745 449.605896,329.356659 448.368164,327.149597 
	C444.407745,332.187164 440.725769,336.525513 437.422272,341.135101 
	C425.964783,357.122437 414.672943,373.228394 403.251251,389.241547 
	C394.870270,400.991638 386.343170,412.637573 377.969147,424.392548 
	C375.257751,428.198669 372.087311,429.987000 367.113373,429.729614 
	C357.988098,429.257355 348.820923,429.595032 338.046448,429.595032 
	C375.056152,377.874603 411.212646,327.346497 448.023254,275.904266 
	C452.959198,282.819092 457.480652,289.153259 462.263702,295.748199 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M582.990417,360.000000 
	C582.990479,332.871521 582.990479,306.243011 582.990479,279.302917 
	C592.047607,279.302917 600.936401,279.302917 609.552856,279.302917 
	C609.552856,319.695374 609.552856,359.993195 609.552856,400.837524 
	C644.931763,400.837524 679.771057,400.837524 714.907166,400.837524 
	C714.907166,410.640900 714.907166,419.901276 714.907166,429.536499 
	C671.013611,429.536499 627.057190,429.536499 582.990356,429.536499 
	C582.990356,406.457214 582.990356,383.478607 582.990417,360.000000 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M859.000000,400.988129 
	C876.139282,400.988129 892.778564,400.988129 909.712280,400.988129 
	C909.712280,410.257263 909.712280,419.329010 909.712280,429.221375 
	C855.378052,429.221375 800.947998,429.221375 746.253052,429.221375 
	C746.253052,419.672394 746.253052,410.601074 746.253052,400.988129 
	C783.664429,400.988129 821.082214,400.988129 859.000000,400.988129 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M759.009155,307.011505 
	C754.534180,307.011475 750.557800,307.011475 746.285645,307.011475 
	C746.285645,297.746155 746.285645,288.677307 746.285645,278.929199 
	C800.650696,278.929199 855.134155,278.929199 909.809753,278.929199 
	C909.809753,287.679474 909.809753,297.107452 909.809753,307.011536 
	C859.625793,307.011536 809.566772,307.011536 759.009155,307.011505 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M1408.001221,344.000000 
	C1408.000854,371.318817 1407.935181,398.137939 1408.069824,424.956055 
	C1408.090088,428.992920 1407.257568,429.737335 1402.985718,429.252625 
	C1395.921143,428.451080 1388.699341,429.034790 1381.270752,429.034790 
	C1381.270752,379.613556 1381.270752,329.606720 1381.270752,278.754333 
	C1389.828247,278.754333 1398.496582,278.754333 1408.001099,278.754333 
	C1408.001099,299.809753 1408.001099,321.654877 1408.001221,344.000000 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M1273.983398,424.403717 
	C1273.768921,426.197845 1273.554932,427.552002 1273.285400,429.256531 
	C1264.688721,429.256531 1256.038696,429.256531 1247.192749,429.256531 
	C1247.192749,392.433533 1247.192749,355.407654 1247.192749,318.184418 
	C1256.007324,318.184418 1264.623901,318.184418 1273.983643,318.184418 
	C1273.983643,353.360718 1273.983643,388.662231 1273.983398,424.403717 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M1179.089111,278.998474 
	C1208.619385,278.997894 1237.661377,278.997894 1266.856201,278.997894 
	C1266.856201,287.764374 1266.856201,297.058624 1266.856201,306.835999 
	C1235.849121,306.835999 1204.823120,306.835999 1173.395142,306.835999 
	C1173.395142,297.885559 1173.395142,288.698883 1173.395142,278.999054 
	C1175.055176,278.999054 1176.827881,278.999054 1179.089111,278.998474 
z"
      />
      <path
        fill="#F8F8F7"
        opacity="1.000000"
        stroke="none"
        d="
M1387.000000,480.987915 
	C1393.990356,480.987518 1400.480713,480.960449 1406.970947,480.993683 
	C1414.500732,481.032257 1420.858887,487.448547 1421.031128,494.909363 
	C1421.248047,504.301422 1421.774658,513.688110 1421.881104,523.080322 
	C1421.963379,530.343506 1413.635376,538.028687 1406.209351,538.011780 
	C1393.395142,537.982544 1380.579468,538.120911 1367.766968,537.971863 
	C1354.846558,537.821594 1351.398804,533.122925 1350.301270,522.670532 
	C1349.278198,512.927856 1350.049072,502.860565 1351.187256,493.070709 
	C1352.080078,485.391724 1357.134399,480.966888 1366.030518,480.983673 
	C1372.853638,480.996552 1379.676880,480.987335 1387.000000,480.987915 
M1383.501709,526.996643 
	C1389.980835,526.994019 1396.460693,527.043335 1402.938965,526.970337 
	C1407.206421,526.922241 1409.899780,524.361267 1409.961304,520.187927 
	C1410.061646,513.377991 1410.306152,506.546448 1409.899780,499.759338 
	C1409.485229,492.834015 1406.891479,491.910828 1401.919556,491.972534 
	C1391.122559,492.106567 1380.322754,492.008606 1369.524170,492.015930 
	C1364.164062,492.019562 1362.084839,493.959991 1362.029419,499.234192 
	C1361.957764,506.044861 1361.964111,512.857361 1362.028931,519.668213 
	C1362.078613,524.890930 1364.201294,526.920349 1369.544800,526.978943 
	C1373.863770,527.026367 1378.183594,526.994446 1383.501709,526.996643 
z"
      />
      <path
        fill="#F9F8F8"
        opacity="1.000000"
        stroke="none"
        d="
M803.000000,368.012756 
	C783.897522,368.012756 765.295105,368.012756 746.339966,368.012756 
	C746.339966,358.938416 746.339966,349.882874 746.339966,340.474060 
	C772.642090,340.474060 799.139282,340.474060 825.819275,340.474060 
	C825.819275,349.297424 825.819275,358.561829 825.819275,368.012726 
	C818.299805,368.012726 810.899902,368.012726 803.000000,368.012756 
z"
      />
      <path
        fill="currentColor"
        opacity="1.000000"
        stroke="none"
        d="
M208.210510,309.879547 
	C196.939774,293.858795 185.853897,278.149658 174.404404,261.925262 
	C176.095932,261.550262 177.001526,261.172852 177.905731,261.176117 
	C187.901627,261.212372 197.906036,261.108215 207.886215,261.543854 
	C210.059708,261.638763 212.888443,263.193176 214.157288,264.972565 
	C225.744568,281.222260 237.058044,297.667267 248.429474,314.070496 
	C248.958313,314.833344 249.278809,315.740631 250.175430,317.544525 
	C247.531464,317.544525 245.622101,317.548065 243.712769,317.543884 
	C236.547852,317.528168 229.321701,316.922760 222.235641,317.661652 
	C215.473984,318.366669 211.070007,316.284241 208.210510,309.879547 
z"
      />
      <path
        fill="#F8F8F7"
        opacity="1.000000"
        stroke="none"
        d="
M1627.993164,487.233459 
	C1627.910645,484.973938 1627.827759,483.187012 1627.725952,480.989960 
	C1645.224854,480.989960 1663.167236,480.976379 1681.109375,481.029877 
	C1682.009155,481.032593 1682.900635,481.636017 1683.806763,481.926392 
	C1692.661621,484.763824 1697.091187,493.543823 1695.331177,502.660980 
	C1694.339600,507.796783 1694.188110,513.438599 1695.208984,518.542297 
	C1696.934448,527.167725 1690.104492,537.914795 1679.104370,537.980042 
	C1662.298462,538.079712 1645.491455,538.006104 1628.338379,538.006104 
	C1628.338379,534.506775 1628.338379,531.099976 1628.338379,527.270813 
	C1629.295776,527.195190 1630.553101,527.011292 1631.810669,527.009521 
	C1645.794678,526.989380 1659.782593,526.796631 1673.760986,527.078796 
	C1681.243408,527.229858 1684.156738,522.740112 1684.016846,516.671692 
	C1683.897949,511.513641 1684.180664,506.341736 1683.938232,501.192352 
	C1683.655518,495.185242 1680.375000,491.655945 1674.610718,491.879395 
	C1663.315796,492.317230 1651.991943,492.008057 1640.287842,492.008057 
	C1640.287842,500.851105 1640.287842,509.587708 1640.287842,518.662109 
	C1636.169556,518.662109 1632.429077,518.662109 1627.992676,518.662109 
	C1627.992676,508.521484 1627.992676,498.113770 1627.993164,487.233459 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M1347.011475,301.892456 
	C1347.011475,303.822388 1347.011475,305.263336 1347.011475,306.818176 
	C1323.150024,306.818176 1299.774902,306.818176 1276.193970,306.818176 
	C1276.193970,297.564392 1276.193970,288.503632 1276.193970,278.906738 
	C1299.695435,278.906738 1323.059814,278.906738 1347.011597,278.906738 
	C1347.011597,286.038635 1347.011597,293.721069 1347.011475,301.892456 
z"
      />
      <path
        fill="#F9F9F8"
        opacity="1.000000"
        stroke="none"
        d="
M477.916321,400.990417 
	C484.600159,399.930206 488.486694,402.091370 491.729553,407.904938 
	C495.752808,415.117432 501.328949,421.463623 506.965210,429.185364 
	C479.391479,429.185364 453.266449,429.185364 427.113586,429.185364 
	C427.113586,419.435760 427.113586,410.486969 427.113586,400.990021 
	C443.964569,400.990021 460.697144,400.990021 477.916321,400.990417 
z"
      />
      <path
        fill="#F7F8F6"
        opacity="1.000000"
        stroke="none"
        d="
M1524.564575,538.010986 
	C1522.165283,538.011597 1520.193726,538.011597 1517.946167,538.011597 
	C1518.313477,531.754150 1518.437500,525.863037 1519.065063,520.026062 
	C1519.678955,514.315979 1515.146484,511.585266 1512.366089,508.074524 
	C1505.230957,499.065002 1497.533813,490.500458 1489.401367,480.985840 
	C1494.513794,480.985840 1498.599976,480.797333 1502.651855,481.088287 
	C1504.065796,481.189819 1505.736572,482.171631 1506.706543,483.267883 
	C1512.661987,489.997772 1518.450073,496.875793 1524.488525,503.931976 
	C1530.570190,497.213379 1536.576172,490.440582 1542.774292,483.848206 
	C1544.005005,482.539307 1545.900146,481.313416 1547.613647,481.112793 
	C1551.187134,480.694244 1554.843750,480.986084 1559.332031,480.986084 
	C1554.439941,487.012634 1550.059814,492.562347 1545.510254,497.969543 
	C1541.019043,503.307312 1536.291504,508.446838 1531.834106,513.811523 
	C1531.097412,514.698242 1531.011353,516.287842 1530.970825,517.563477 
	C1530.755005,524.374207 1530.649414,531.188416 1530.505493,538.010315 
	C1527.917480,538.010315 1526.454956,538.010315 1524.564575,538.010986 
z"
      />
      <path
        fill="#F8F8F7"
        opacity="1.000000"
        stroke="none"
        d="
M1142.942627,538.012817 
	C1128.478638,538.012817 1114.505371,538.012817 1099.960205,538.012817 
	C1099.960205,519.038513 1099.960205,500.307648 1099.960205,481.287109 
	C1103.392822,481.287109 1107.407959,481.287109 1111.822998,481.287109 
	C1111.822998,496.257019 1111.822998,511.335907 1111.822998,526.812500 
	C1126.616333,526.812500 1141.025757,526.812500 1155.182251,526.812500 
	C1155.613770,527.466858 1155.963989,527.753174 1155.930786,527.984192 
	C1155.419067,531.530640 1156.040527,536.619995 1153.985107,538.188782 
	C1151.790894,539.863464 1147.058105,538.212219 1142.942627,538.012817 
z"
      />
      <path
        fill="#F8F8F7"
        opacity="1.000000"
        stroke="none"
        d="
M1238.012939,521.885254 
	C1238.012939,523.814209 1238.012939,525.254944 1238.012939,526.883423 
	C1252.427246,526.883423 1266.359009,526.883423 1280.648438,526.883423 
	C1280.648438,530.584167 1280.648438,534.097900 1280.648438,537.818970 
	C1262.552002,537.818970 1244.505005,537.818970 1226.222412,537.818970 
	C1226.222412,518.973145 1226.222412,500.260712 1226.222412,481.266724 
	C1229.950928,481.266724 1233.688721,481.266724 1238.012939,481.266724 
	C1238.012939,494.589813 1238.012939,507.993439 1238.012939,521.885254 
z"
      />
      <path
        fill="currentColor"
        opacity="1.000000"
        stroke="none"
        d="
M951.211731,514.963745 
	C948.762573,514.605713 945.207520,514.534912 945.075806,513.827087 
	C944.519104,510.835358 944.872192,507.642029 945.210449,504.557251 
	C945.252441,504.174896 947.197205,503.764282 948.259766,503.765411 
	C974.354919,503.793243 1000.451355,504.030060 1026.544067,503.814453 
	C1031.669189,503.772125 1031.512695,506.242615 1031.749634,509.869507 
	C1032.024414,514.075195 1030.693604,515.124817 1026.467529,515.085388 
	C1001.540405,514.852539 976.609924,514.963074 951.211731,514.963745 
z"
      />
      <path
        fill="currentColor"
        opacity="1.000000"
        stroke="none"
        d="
M1776.011108,503.920776 
	C1800.637573,503.915405 1824.765625,503.915405 1849.301392,503.915405 
	C1849.301392,507.445038 1849.301392,510.820801 1849.301392,514.679688 
	C1820.687256,514.679688 1792.165649,514.679688 1763.678345,514.679688 
	C1763.464111,514.326416 1763.165283,514.058838 1763.149780,513.775696 
	C1762.609863,503.965668 1762.613647,503.965454 1776.011108,503.920776 
z"
      />
      <path
        fill="currentColor"
        opacity="1.000000"
        stroke="none"
        d="
M833.116516,356.986267 
	C833.115417,351.212585 833.115417,345.932312 833.115417,340.334290 
	C842.555359,340.334290 851.800110,340.334290 861.569092,340.334290 
	C861.569092,349.519135 861.569092,358.725983 861.569092,368.328156 
	C852.309387,368.328156 843.084167,368.328156 833.117615,368.328156 
	C833.117615,364.671814 833.117615,361.075745 833.116516,356.986267 
z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
M1383.002441,526.997192 
	C1378.183594,526.994446 1373.863770,527.026367 1369.544800,526.978943 
	C1364.201294,526.920349 1362.078613,524.890930 1362.028931,519.668213 
	C1361.964111,512.857361 1361.957764,506.044861 1362.029419,499.234192 
	C1362.084839,493.959991 1364.164062,492.019562 1369.524170,492.015930 
	C1380.322754,492.008606 1391.122559,492.106567 1401.919556,491.972534 
	C1406.891479,491.910828 1409.485229,492.834015 1409.899780,499.759338 
	C1410.306152,506.546448 1410.061646,513.377991 1409.961304,520.187927 
	C1409.899780,524.361267 1407.206421,526.922241 1402.938965,526.970337 
	C1396.460693,527.043335 1389.980835,526.994019 1383.002441,526.997192 
z"
      />
    </svg>
  );
};

export default ValentinoLogo;
